import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import PickupForm from 'common/components/address/PickupForm';
import PickupLocationForm from 'common/components/address/PickupLocationForm';
import { initialFormValues } from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import { getDefaultCountryCode, getCartTitle } from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { phoneFormatForDB } from 'common/helpers/phoneHelper';
import { updateCart } from 'redux/cart/actions';
import { listPickupLocations } from 'redux/inventoryLocations/actions';

import Email from './components/Email';
import RombauerPickupBy from './components/RombauerPickupBy';
import { validateForNotLoggedInCustomerPickup } from './validators';

class Customer extends Component {
  componentDidMount() {
    const { props } = this;
    props.listPickupLocations();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const cart = {
      email: data.email,
      isSubscribe: data.isSubscribe,
      pickupBy: data,
      orderDeliveryMethod: 'Pickup',
      giftMessage: null,
      shippingInstructions: null
    };
    if (form['pickup-by']) {
      cart.metaData = {
        'pickup-by': form['pickup-by']
      };
    }
    delete cart.pickupBy.email;
    delete cart.pickupBy.isSubscribe;
    const successFunction = () => {
      props.onEdit('shipping');
    };
    props.updateCart(cart, successFunction);
  };

  handleShip = (e) => {
    e.preventDefault();
    const { onShip } = this.props;
    onShip();
  };

  render() {
    const { handleSubmit, form, formValues } = this.props;
    const { inventoryLocation, settings } = this.props;
    if (!inventoryLocation.data || !formValues) {
      return null;
    }
    const title = getCartTitle(settings);
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <Email />
        <p>&nbsp;</p>
        <div className="c7-checkout__content__title">
          <h3>Pickup By</h3>
          <a
            className="c7-checkout__content__title__ship"
            onClick={this.handleShip}
          >
            I prefer to have my order shipped
          </a>
        </div>
        <PickupForm />
        <h3>Pickup At</h3>
        <PickupLocationForm
          formValues={formValues}
          inventoryLocation={inventoryLocation}
        />

        <RombauerPickupBy />

        <div className="c7-checkout__content__buttons">
          <button className="c7-button" type="submit">
            Continue to payment method
          </button>
          <a href="/cart">Return to {title.toLowerCase()}</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    firstName: values.firstName,
    lastName: values.lastName,
    phone: phoneFormatForDB(values.phone, values.countryCode),
    countryCode: values.countryCode,
    email: values.email,
    isSubscribe: values.isSubscribe || false,
    inventoryLocationId: values.inventoryLocationId
  };

  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateForNotLoggedInCustomerPickup(data, ownProps.settings);
  return errors;
};

const getFirstInventoryLocation = (inventoryLocation) => {
  if (!inventoryLocation || !inventoryLocation.data) {
    return null;
  }
  const inventoryLocationIdArray = Object.keys(inventoryLocation.data);

  return inventoryLocationIdArray[0];
};

const mapStateToProps = (state) => {
  let initialValues = {};
  if (state.cart && state.cart.data && state.cart.data.pickupBy) {
    const { pickupBy, metaData } = state.cart.data;
    initialValues = Object.assign(initialValues, initialFormValues(pickupBy));
    initialValues.email = state.cart.data.email;
    initialValues.isSubscribe = state.cart.data.isSubscribe;
    if (metaData?.['pickup-by']) {
      initialValues['pickup-by'] = metaData['pickup-by'];
    }
  } else {
    initialValues.countryCode = getDefaultCountryCode(state.setting);
    initialValues.inventoryLocationId = getFirstInventoryLocation(
      state.inventoryLocation
    );
  }
  return {
    initialValues,
    settings: state.setting,
    inventoryLocation: state.inventoryLocation,
    formValues:
      state.form.customerNotLoggedInPickup &&
      state.form.customerNotLoggedInPickup.values
  };
};

Customer = reduxForm({
  form: 'customerNotLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Customer);

export default connect(mapStateToProps, { updateCart, listPickupLocations })(
  Customer
);
